exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".Headline__headline___2j7yW {\n    font-weight: 500;\n    margin-bottom: 25px;\n}\n\n.Headline__pageTitle___Z2BAv {\n    margin: 30px 0;\n}\n\n.Headline__grey___N9EfF {\n    color: grey;\n}\n\n.Headline__orange___302_f {\n    color: #ff8e42;\n}\n\n.Headline__center___3EFKR {\n    text-align: center;\n}\n\n.Headline__subtitle___1Ifmf {\n    margin-top: -15px;\n    margin-bottom: 40px;\n    font-weight: 300;\n}\n\n.Headline__small___3J-ve {\n    font-weight: 300;\n}\n\n@media screen and (max-width: 990px) {\n    .Headline__headline___2j7yW {\n        font-size: 32px;\n    }\n\n    .Headline__headline___2j7yW br {\n        display: none;\n    }\n}\n", ""]);

// exports
exports.locals = {
	"headline": "Headline__headline___2j7yW",
	"pageTitle": "Headline__pageTitle___Z2BAv",
	"grey": "Headline__grey___N9EfF",
	"orange": "Headline__orange___302_f",
	"center": "Headline__center___3EFKR",
	"subtitle": "Headline__subtitle___1Ifmf",
	"small": "Headline__small___3J-ve"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":true,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/Headline/Headline.css
// module id = 329
// module chunks = 0